import React from 'react';
import { Typography, Box } from '@mui/material';
import { BillingEntity } from './BillingEntity';
import {FarmDetails } from './LandlordDetails';
import styles from './AddFarmBillingEntity.module.scss';
import { LandlordName } from './LandlordName';
import { LandlordField } from "./LandlordField";
import { RenameEntities } from './RenameEntities';

const AddFarm: React.FC = () => {
  return (
    <div className={styles.containerView}>
      <Typography variant="h5" color="primary" sx={{ flex: 1 }}>
        Add New Billing Entity
      </Typography>
      <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
        <div className={styles.formView}>
          <Box display={"flex"} flexWrap={"wrap"}>
            <Box flex={1}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  padding: "10px 0px",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    margin: 0,
                    color: "#334155",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "20px",
                    fontWeight: 600,
                    lineHeight: "28px",
                  }}
                >
                  Add New Billing Entity
                </Typography>
              </Box>
              <BillingEntity />
            </Box>
            <Box flex={1}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  padding: "10px 0px",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    margin: 0,
                    color: "#334155",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "20px",
                    fontWeight: 600,
                    lineHeight: "28px",
                  }}
                >
                  Add New Landlord
                </Typography>
              </Box>
              <LandlordName />
            </Box>
          </Box>
        </div>
        <div className={styles.formView}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              padding: "10px 0px",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                margin: 0,
                color: "#334155",
                fontFamily: "Poppins, sans-serif",
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "28px",
              }}
            >
              Rename Landlord &amp; Billing Entity
            </Typography>
          </Box>
          <RenameEntities />
        </div>
        <div className={styles.formView}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              padding: "10px 0px",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                margin: 0,
                color: "#334155",
                fontFamily: "Poppins, sans-serif",
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "28px",
              }}
            >
              Map Landlord to Field
            </Typography>
          </Box>
          <LandlordField />
        </div>
        <div className={styles.formView}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              padding: "10px 0px",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                margin: 0,
                color: "#334155",
                fontFamily: "Poppins, sans-serif",
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "28px",
              }}
            >
              Map Landlord to billing entity
            </Typography>
          </Box>
          <FarmDetails />
        </div>
      </Box>
    </div>
  );
};

export default AddFarm;
